import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {Race} from '@app/rest-client/faxe/models/race';
import { select, Store } from '@ngrx/store';
import { RootState } from '@app/store/root-state';
import { filter } from 'rxjs/operators';
import { isNotEmpty } from '@app/fremework/functions';
import { fetchAllRaces } from '@app/store/faxe/race/race.actions';
import { selectRaceByRaceGuid, selectRaces } from '@app/store/faxe/race/race.selectos';

@Injectable({
  providedIn: 'root'
})
export class RaceFacadeService {

  constructor(private store: Store<RootState>) {
  }

  fetchRace(issuer: string): Observable<Race[]> {
    this.store.dispatch(
      fetchAllRaces(
        {issuerStack: [issuer]}));

    return this.store.pipe(
      select(selectRaces()),
      filter((races) => isNotEmpty(races)));
  }

  fetchRaceByRaceGuid(raceGuid: string, issuer: string): Observable<Race> {
    this.store.dispatch(
      fetchAllRaces(
        {issuerStack: [issuer]}));

    return this.store.pipe(
      select(selectRaceByRaceGuid(raceGuid)));
  }

}
